module.exports = __webpack_public_path__ + "static/chillter-export-281e31eb5f71e96f1d77f0c5ea795281.mp4";